// basic router implementation
// -----------
// https://router.vuejs.org/en/essentials/getting-started.html

import Vue from 'vue'
import Router from 'vue-router'
import OnepagerContainer from '../components/onepager/OnepagerContainer.vue'
import Report from '../components/report/Report.vue'
import Factsheet from '../components/factsheet/Factsheet.vue'
import EquivalenceCheck from '../components/equivalence-check/EquivalenceCheck.vue'
import Document from '../components/document/DocumentContainer.vue'
import Shortlist from "../components/shortlist/Shortlist"
import MultiReport from "../components/multi-report/MultiReport"
import TmcExport from "../components/tmc-export/TmcExport"
import TmcMultiExport from "../components/tmc-export/TmcMultiExport"
import Offerte from "../components/offerte/Offerte"
import ProductEquivalenceCheck from "../components/equivalence-check/ProductEquivalenceCheck"
import ProductList from "../components/product-list/ProductList"
import Whitelabel from "../components/whitelabel/Whitelabel.vue";
import Approval from "../components/approval/Approval.vue";
import Ddf from "../components/ddf/Ddf.vue";
import Portfolio from "../components/portfolio/Portfolio.vue";
import TmcHistoryExport from "../components/tmc-export/TmcHistoryExport.vue"
import Emissions from "../components/emissions/Emissions.vue"

Vue.use(Router)

export default new Router({
  routes: [

    // NEW API

    {
      path: '/onepager/:environment/:appInstance/:productIds',
      name: 'OnepagerContainer',
      component: OnepagerContainer,
      props: true
    },
    {
      path: '/product-list/:environment/:appInstance/:productIds',
      name: 'ProductList',
      component: ProductList,
      props: true
    },
    {
      path: '/offerte/:environment/:appInstance/:productIds',
      name: 'Offerte',
      component: Offerte,
      props: true
    },
    {
      path: '/emissions/:environment/:appInstance/:productIds',
      name: 'Emissions',
      component: Emissions,
      props: true
    },
    {
      path: '/report/:environment/:appInstance/:dq/',
      name: 'Report',
      component: Report,
      props: true
    },
    {
      path: '/multi-report/:environment/:appInstance/:dqs',
      name: 'MultiReport',
      component: MultiReport,
      props: true
    },
    {
      path: '/whitelabel/:environment/:appInstance',
      name: 'Whitelabel',
      component: Whitelabel,
      props: true
    },
    {
      path: '/factsheet/:environment/:appInstance/:dq/',
      name: 'Factsheet',
      component: Factsheet,
      props: true
    },
    {
      path: '/equivalence-check/:environment/:appInstance/:watchlistId/:ecId',
      name: 'EquivalenceCheck',
      component: EquivalenceCheck,
      props: true
    },
    {
      path: '/product-equivalence-check/:environment/:appInstance/:productId/:ecId',
      name: 'ProductEquivalenceCheck',
      component: ProductEquivalenceCheck,
      props: true
    },
    {
      path: '/shortlist/:environment/:appInstance/:shortlistId',
      name: 'Shortlist',
      component: Shortlist,
      props: true
    },
    {
      path: '/tmc-export/:environment/:appInstance/:dq',
      name: 'TmcExport',
      component: TmcExport,
      props: true
    },
    {
      path: '/tmc-multi-export/:environment/:appInstance/:watchlistId',
      name: 'TmcMultiExport',
      component: TmcMultiExport,
      props: true
    },
    {
      path: '/tmc-history-export/:environment/:appInstance/:id',
      name: 'TmcHistoryExport',
      component: TmcHistoryExport,
      props: true
    },
    {
      path: '/documentTester',
      name: 'DocumentTest',
      component: Document,
      props: true
    },
    {
      path: '/approval-process/:id',
      name: 'Approval',
      component: Approval,
      props: true
    },
    {
      path: '/ddf/language/:language/type/:type',
      name: 'Ddf',
      component: Ddf,
      props: true
    },
    {
      path: '/ddf/language/:language',
      name: 'DdfComplete',
      component: Ddf,
      props: true
    },
    {
      path: '/portfolio/:environment/:appInstanceId/:moduleId/:simulationId/:figuresId',
      name: 'Portfolio',
      component: Portfolio,
      props: true
    },

    // OLD API - deprecated

    {
      path: '/onepager/:environment/:productIds',
      name: 'OnepagerContainerOld',
      component: OnepagerContainer,
      props: true
    },
    {
      path: '/report/:environment/:dq/',
      name: 'ReportOld',
      component: Report,
      props: true
    },
    {
      path: '/multi-report/:environment/:dqs',
      name: 'MultiReportOld',
      component: MultiReport,
      props: true
    },
    {
      path: '/factsheet/:environment/:dq/',
      name: 'FactsheetOld',
      component: Factsheet,
      props: true
    },
    {
      path: '/equivalence-check/:environment/:watchlistId/:ecId',
      name: 'EquivalenceCheckOld',
      component: EquivalenceCheck,
      props: true
    },
    {
      path: '/shortlist/:environment/:shortlistId',
      name: 'ShortlistOld',
      component: Shortlist,
      props: true
    },
    {
      path: '/tmc-export/:environment/:dq',
      name: 'TmcExportOld',
      component: TmcExport,
      props: true
    },
    {
      path: '/tmc-multi-export/:environment/:watchlistId',
      name: 'TmcMultiExportOld',
      component: TmcMultiExport,
      props: true
    }

  ]
})





// WEBPACK FOOTER //
// ./src/core/Router.js